import React, { useEffect, useState } from "react";
import "./BlockManagement.scss";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import Pagination from "../../utils/Pagination";
import {
  createBlock,
  deleteBlock,
  fetchBlockById,
  fetchBlocks,
  updateBlock,
} from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";

const BlockManagement = () => {
  const [blockManagement, setBlockManagement] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blockToDelete, setBlockToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const blocksPerPage = 10;
  const [sortAscending, setSortAscending] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    activeStatus: true,
  });

  const [errors, setErrors] = useState({
    id: 0,
    name: "",
    activeStatus: "",
  });
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const validateForm = () => {
    let formErrors = { name: "", activeStatus: "" };
    let valid = true;

    if (formData.name.trim() === "") {
      formErrors.name = "Block name is required";
      valid = false;
    }

    if (formData.activeStatus === null || formData.activeStatus === undefined) {
      formErrors.activeStatus = "Please select a status";
      valid = false;
    }

    setErrors(formErrors);
    return valid;
  };
  const fetchBlockManagement = async () => {
    setLoading(true);
    try {
      const response = await fetchBlocks();
      setBlockManagement(response.data);
    } catch (error) {
      console.error("Error fetching block data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBlockManagement();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);

    if (isModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
    }
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
    if (isEditModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
      fetchBlockManagement();
    }
  };

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setBlockToDelete(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };
  const handleSortByName = () => {
    setSortAscending(!sortAscending); // Toggle sorting order
  };
  const filteredBlocks = blockManagement
    .filter(
      (block) =>
        block.name &&
        block.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortAscending) {
        return a.name.localeCompare(b.name); // Ascending order by name
      } else {
        return b.name.localeCompare(a.name); // Descending order by name
      }
    });

  const pageCount = Math.ceil(filteredBlocks.length / blocksPerPage);

  const getCurrentPageBlocks = () => {
    const startIndex = currentPage * blocksPerPage;
    const endIndex = startIndex + blocksPerPage;
    return filteredBlocks.slice(startIndex, endIndex);
  };

  const handleCancel = () => {
    setFormData({
      id: 0,
      name: "",
      activeStatus: true,
    });
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setIsDeleteModalOpen(false);
    setBlockToDelete(null);
    setErrors({
      name: "",
      activeStatus: "",
    });
  };

  const handleAddBlock = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    setIsModalOpen(false);
    setLoading(true);
    try {
      const response = await createBlock(formData);
      console.log(response.data);
      setAlert({
        visible: true,
        message: "Block added successfully!",
        type: "success",
      });

      handleCancel();
      fetchBlockManagement();
    } catch (error) {
      console.error("Error adding block:", error);

      setAlert({
        visible: true,
        message: "Error adding block. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEditBlock = async (id) => {
    setIsEditModalOpen(false);
    console.log(formData);
    try {
      const response = await fetchBlockById(id);
      setFormData(response.data);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching block details:", error);
    }
  };

  console.log(formData);

  const handleSaveEditBlock = async () => {
    if (!validateForm()) {
      return;
    }
    setIsEditModalOpen(false);
    setLoading(true);
    try {
      const response = await updateBlock(formData.id, formData);
      console.log(response.data);
      setAlert({
        visible: true,
        message: "Block updated successfully!",
        type: "success",
      });

      handleCancel();
      fetchBlockManagement();
    } catch (error) {
      console.error("Error updating block:", error);
      setAlert({
        visible: true,
        message: "Error adding block. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBlock = async () => {
    if (!blockToDelete) return;
    setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      await deleteBlock(blockToDelete.id);
      handleCancel();
      setAlert({
        visible: true,
        message: "Block deleted successfully!",
        type: "success",
      });
      fetchBlockManagement();
    } catch (error) {
      console.error("Error deleting block:", error);
      setAlert({
        visible: true,
        message: "Error deleting block. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIconClick = (block) => {
    setBlockToDelete(block);
    setIsDeleteModalOpen(true);
  };

  return (
    <div className="houseState">
      {loading && <Loading />}
      {!loading && (
        <div className="houseState-container box-shadow ">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
          <div className="container-head p-15">
            <h2>Block Management</h2>
            <div className="btns">
              <span className="add-btn" onClick={toggleModal}>
                <IoIosAddCircleOutline />
                <p>Add Block</p>
              </span>
            </div>
          </div>
          <div className="table-filters">
            <div className="search-filter">
              <label htmlFor="searchName">
                <FaSearch />
              </label>
              <input
                type="text"
                maxLength={50}
                id="searchName"
                placeholder="Search by Block Name"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="houseState-content" style={{ overflowX: "auto" }}>
            <div className="table-container ">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th
                      onClick={handleSortByName}
                      style={{ cursor: "pointer" }}
                    >
                      Block Management{" "}
                      {sortAscending ? (
                        <RiSortAlphabetAsc />
                      ) : (
                        <RiSortAlphabetDesc />
                      )}
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {getCurrentPageBlocks().length > 0 ? (
                    getCurrentPageBlocks().map((item) => (
                      <tr key={item.id}>
                        <td className="text-left">{item.name}</td>
                        <td className="text-center">
                          <p
                            className={
                              item.activeStatus ? "active" : "inactive"
                            }
                          >
                            {item.activeStatus ? "Active" : "Inactive"}{" "}
                          </p>
                        </td>
                        <td className="text-center">
                          <LuFileEdit
                            onClick={() => handleEditBlock(item.id)}
                          />{" "}
                          <FaRegTrashCan
                            onClick={() => handleDeleteIconClick(item)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No blocks found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                pageCount={pageCount}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
      )}

      {/* Add Block Modal */}
      {isModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Add Name</h3>
              <span className="close-icon" onClick={toggleModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className={`add-form ${errors.name ? "error" : ""}`}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleAddBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Block Modal */}
      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit Name</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className="add-form">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
              </div>
              <div className="add-form">
                <label htmlFor="activeStatus">Active Status:</label>
                <div className="custom-radio-group">
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                  {errors.activeStatus && (
                    <span className="error-message">{errors.activeStatus}</span>
                  )}
                </div>
              </div>

              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleSaveEditBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="screen">
          <div className="screen-container delete-popup">
            <h2>Are you sure you want to delete?</h2>
            <p>This action is permanent and cannot be undone.</p>

            <button
              onClick={handleDeleteBlock}
              className="delete btn"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </button>
            <button className="btn-cancel" onClick={toggleDeleteModal}>
              No, Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockManagement;
